
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ITag } from "@/models/tag.entity";
import { Component, Prop } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import TagChip from "./TagChip.vue";

@Component({ components: { TagChip, Tooltip } })
export default class TagPreview extends PermissionMixin {
  @Prop({ default: false })
  value!: ITag[];

  @Prop({ default: 1 })
  amount?: number;

  @Prop({ default: "medium" })
  size?: "x-small" | "small" | "medium" | "large" | "x-large";

  get first() {
    if (this.amount) {
      return this.value.slice(0, this.amount);
    }

    return this.value;
  }

  get remaining() {
    if (this.amount) {
      return this.value.slice(this.amount);
    }

    return [];
  }

  get partnerId() {
    if (this.value.length) {
      return this.value[0].partnerId;
    }

    return undefined;
  }
}
